import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import SignatureInput from "./SignatureInput";

import {
    getFormattedPhoneNumber,
    isValidEmail,
    isValidName,
    isValidPhoneNumber,
} from "../utils/utils";

const SubVendorLastFields = () => {
    const {
        register,
        formState: { isSubmitting, errors },
        setValue,
    } = useFormContext();

    const updatePhoneNumber = e => {
        const number = getFormattedPhoneNumber(e.target.value);
        setValue("phone", number);
    };

    return (
        <Row as="fieldset" className="sub-vendor-last-fields">
            <Form.Group as={Col} xs={12} className="mb-4">
                <Form.Check
                    type="checkbox"
                    size="lg"
                    label="I hereby acknowledge that all information on this
                    application is true. I understand that if the staffing
                    company listed on page one of this application is approved
                    to move forward, all parties agree that all communication
                    and executed agreements are between the staffing vendor
                    company and ShiftMed Unlimited."
                    {...register("acknowledge_information", {
                        required:
                            "Please check the box to confirm that you acknowledge and understand the statement.",
                    })}
                />
                {errors["acknowledge_information"]?.message && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                        {errors["acknowledge_information"].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <SignatureInput />

            <Form.Group as={Col} md={6} className="mb-4">
                <Form.Label>
                    Date <span className="required-label">*</span>
                </Form.Label>
                <Form.Control
                    type="date"
                    size="lg"
                    {...register("date", {
                        required: "This field is required",
                    })}
                    isInvalid={!!errors["date"]}
                    onClick={e => e.target.showPicker()}
                />
                {errors["date"]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors["date"].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group as={Col} md={6} className="mb-4">
                <Form.Label>
                    Name <span className="required-label">*</span>
                </Form.Label>
                <Form.Control
                    type="text"
                    size="lg"
                    {...register("name", {
                        required: "This field is required",
                        validate: value => isValidName(value) || "Invalid name",
                    })}
                    isInvalid={!!errors["name"]}
                />
                {errors["name"]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors["name"].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group as={Col} md={6} className="mb-4">
                <Form.Label>
                    Title <span className="required-label">*</span>
                </Form.Label>
                <Form.Control
                    type="text"
                    size="lg"
                    {...register("title", {
                        required: "This field is required",
                    })}
                    isInvalid={!!errors["title"]}
                />
                {errors["title"]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors["title"].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group as={Col} md={6} className="mb-4">
                <Form.Label>
                    Email <span className="required-label">*</span>
                </Form.Label>
                <Form.Control
                    type="email"
                    size="lg"
                    {...register("email", {
                        required: "This field is required",
                        validate: value =>
                            isValidEmail(value) || "Invalid email format.",
                    })}
                    isInvalid={!!errors["email"]}
                />
                {errors["email"]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors["email"].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group as={Col} md={6} className="mb-4">
                <Form.Label>
                    Phone <span className="required-label">*</span>
                </Form.Label>
                <Form.Control
                    type="tel"
                    maxLength="14"
                    size="lg"
                    {...register("phone", {
                        required: "This field is required",
                        onChange: e => updatePhoneNumber(e),
                        validate: value =>
                            isValidPhoneNumber(value) ||
                            "Invalid phone number format.",
                    })}
                    isInvalid={!!errors["phone"]}
                />
                {errors["phone"]?.message && (
                    <Form.Control.Feedback type="invalid">
                        {errors["phone"].message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>

            <Col xs={12}>
                <Button
                    disabled={isSubmitting}
                    className="d-flex ms-auto"
                    type="submit"
                >
                    Submit
                </Button>
            </Col>
        </Row>
    );
};

export default SubVendorLastFields;
